var _path, _path2, _path3, _path4, _circle, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemittanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 13c.8-2.4 4.833-7.667 7-9 12.5-8.5 20.5 1.5 8.5 8.5-4.511 2.632-5.109 3.876 1 4.5 3.026.309 11-2.5 13.5 2.5 3.688 7.375-9 8-14.5 11.5C11.011 36.402 7 37 7 33.5s6-14 2.5-14.5S3 16 4 13Z",
    fill: "#D4DCE5",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m23.057 30.62-7.884 8.567.44-11.335 7.444 2.768Z",
    fill: "#4965A0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.428 24.88 35.786 9.028a.148.148 0 0 1 .203.187L26.8 32.943a.148.148 0 0 1-.186.087L3.445 25.153a.148.148 0 0 1-.017-.273Z",
    fill: "#A4B2CF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m15.174 39.187-2.93-11.067L33.65 11.166l-10.014 11.88-6.108 6.885-2.353 9.256Z",
    fill: "#778CB8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.042,
    cy: 12.589,
    r: 11.703,
    fill: "url(#a)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m18.21 20.475-.008-1.813a8.794 8.794 0 0 1-2.288-.4 1.095 1.095 0 0 1-.729-1.318l.017-.071a1.1 1.1 0 0 1 1.417-.778 6.253 6.253 0 0 0 2.069.353c1.084-.003 1.833-.427 1.824-1.19-.004-.727-.618-1.18-2.033-1.654-2.047-.68-3.437-1.63-3.442-3.48-.007-1.675 1.171-2.995 3.212-3.406l-.008-1.812 1.869-.004.018 1.68a8.133 8.133 0 0 1 1.743.25c.583.154.935.75.78 1.333a1.104 1.104 0 0 1-1.376.788 6.068 6.068 0 0 0-1.672-.231c-1.24.003-1.642.54-1.634 1.075.001.63.675 1.03 2.297 1.63 2.274.789 3.193 1.838 3.198 3.551.005 1.695-1.191 3.15-3.386 3.541l.01 1.949-1.878.007Z",
    fill: "#DCE3F1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 7.339,
    y1: 2.446,
    x2: 30.755,
    y2: 24.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C3F88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4965A0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemittanceIcon);
export default __webpack_public_path__ + "static/media/remittance-icon.a35dd9d968b39efd5572842587da987d.svg";
export { ForwardRef as ReactComponent };